/**
 * The client's first screen. A bot button opens the app with `?tab=`
 * (src/bot/app-link.ts); a t.me link with `startapp=`. `journal` is My
 * profile scrolled to the journal. Anything else, a coach's tab included,
 * is Book, as before. The link wins over startapp.
 */
export type ClientTab = 'book' | 'bookings' | 'profile';

export function startTab(search: string, start?: string | null): { tab: ClientTab; journal: boolean } {
  const want = new URLSearchParams(search).get('tab') ?? start?.toLowerCase() ?? '';
  if (want === 'journal') return { tab: 'profile', journal: true };
  if (want === 'profile' || want === 'bookings') return { tab: want, journal: false };
  return { tab: 'book', journal: false };
}
